import { useCart } from '@hooks/use-cart';

import { ListItemWithPrice } from './list-item-with-price';

export default function PlanPlusOptionHeader({ total }: Readonly<{ total: number }>) {
    const { byouCart } = useCart();
    const subtitle = byouCart && byouCart?.options.length > 0 ? 'Forfait + Options' : 'Forfait';
    return (
        <ListItemWithPrice
            mainTitle='À régler par mois'
            subTitle={subtitle}
            amount={total}
            subTitleClassName='has-text-weight-normal'
            titleClassName='has-text-white'
            period='mois'
            id='SummaryBox'
        />
    );
}
